import { api } from 'api';

import { CaregiverPerformanceResponse } from 'types/caregiverPerformanceDashboard';

import { useErrorHandledQuery } from 'hooks/useErrorHandledQuery';
import { formatApiParams, useToken } from 'lib/common';

type DashboardReadParams = {
    branchId: number;
    startPeriod?: string;
    endPeriod?: string;
};

export const useCaregiverPerformanceDetails = (jsonParams: DashboardReadParams) => {
    const params = jsonParams ? formatApiParams(jsonParams) : undefined;
    const token = useToken();

    return useErrorHandledQuery(
        ['caregiver-performance-details', jsonParams],
        async (): Promise<CaregiverPerformanceResponse> =>
            (
                await api.get(`/dashboard/performance-details`, {
                    headers: {
                        authorization: token,
                    },
                    params,
                })
            ).data.response,
        { enabled: !!(jsonParams?.startPeriod || jsonParams?.endPeriod), staleTime: 300000 }
    );
};
